import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';

lessRequire('modules/tickets/list/components/attention-block.less');

const AttentionBlock = props => {
	const { ticketParams, intl } = props;

	const faqUrl = process.env.CPA_ENV == 'everad' ? '//everad.com/faq' : '//rocketprofit.com/faq';

	if (ticketParams.type === 'offer-access') {
		return (
			<div>
				<p>
					{intl('Для получения доступа к офферу просим ответить вас на пару вопросов непосредственно в этом тикете:')}
				</p>
				<p>
					{intl('1) Работали ли вы с другими партнерскими сетями?')}
				</p>
				<p>
					{intl('2) Какие источники трафика планируете использовать в своей работе?')}
				</p>
				<p>
					{intl('3) Какой кап нужен на запуск? (лиды дейли)')}
				</p>
				<p>
					<strong>
						{intl('Для согласования ставок обратитесь к вашему персональному менеджеру')}
					</strong>
				</p>
			</div>
		);
	} else if (ticketParams.type === 'new-landing') {
		return (
			<p>
				{intl('Пожалуйста, укажите в тикете ссылку на нужный лэндинг/транзитку.')}
			</p>
		);
	} else {
		return (
			<ul>
				<li className="icon-qa">
					<p>
						{intl('Для экономии вашего времени')}&nbsp;
						<a href={faqUrl}>
							{intl('Часто задаваемые вопросы')} <span className="arrow-right" />
						</a>
					</p>
				</li>
				<li className="icon-time">
					<p>
						{intl('Время ответа обратной связи от мгновенного до')}
					</p>
				</li>
			</ul>
		);
	}
};

AttentionBlock.propTypes = {
	ticketParams: PropTypes.object,
	intl: PropTypes.func
};

export default AttentionBlock;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/list/components/attention-block.js